module.exports = __webpack_public_path__ + "static/media/session6grayscale.b0a8e05f.svg";